import React from 'react';

export function SecurityTab() {
  return (
    <div className="space-y-4">
      <p className="text-sm font-medium" style={{ color: 'var(--color-text)' }}>
        Security
      </p>
      <p className="text-xs" style={{ color: 'var(--color-text)', opacity: 0.6 }}>
        Security settings coming soon.
      </p>
    </div>
  );
}
